import { render, staticRenderFns } from "./TaskEditor.vue?vue&type=template&id=24bb4b88&scoped=true&"
import script from "./TaskEditor.vue?vue&type=script&lang=js&"
export * from "./TaskEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb4b88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24bb4b88')) {
      api.createRecord('24bb4b88', component.options)
    } else {
      api.reload('24bb4b88', component.options)
    }
    module.hot.accept("./TaskEditor.vue?vue&type=template&id=24bb4b88&scoped=true&", function () {
      api.rerender('24bb4b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/TaskEditor.vue"
export default component.exports